import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';


import moment from "moment";

import { historyRequests } from "../Utils/Api";

const PointsHistory = props => {
  const [historyData, getHistoryData] = useState([]);
  const { t } = useTranslation( 'points_history' );

  useEffect(() => {
    historyRequests
      .getHistoryOfPoints(props.bloggerId, props.subscriber.id)
      .then(data => {
        getHistoryData(data.data);
      })
      .catch(err => console.log(err));
  }, [props]);

  const dateParcer = date => {
    let dateUTC = moment.utc(date).toDate();
    let localDay = moment(dateUTC)
      .local()
      .format("DD");

    let localMounth = moment(dateUTC)
      .local()
      .format("MM");

    let localYear = moment(dateUTC)
      .local()
      .format("YYYY");

    return localDay + "." + localMounth + "." + localYear;
  };
  const timeParcer = time => {
    let timeUTC = moment.utc(time).toDate();
    let localHour = moment(timeUTC)
      .local()
      .format("HH");
    let localMinute = moment(timeUTC)
      .local()
      .format("mm");

    return localHour + ":" + localMinute;
  };
  return (
    <div className="subscriber_history">
      <div className="subscriber_history_header">
        <div></div>
        <p style={{ textAlign: "center" }}>{props.subscriber.name}</p>
        <div className="close_history">
          <p onClick={() => props.close(false)}>X</p>
        </div>
      </div>
      <div className="subscriber_history_label">
        <p className="subscriber_history_label_p">{ t("История") }:</p>
        <ul className="subscriber_history_list">
          {historyData &&
            historyData.map((item, index) => {
              return (
                <li key={index} id={item.id}>
                  <div className="subscriber_history_list_date">
                    <div>
                      <p>{dateParcer(item.createdAt)}</p>
                      <p>{timeParcer(item.createdAt)}</p>
                    </div>
                  </div>
                  <div>{item.points > 0 ? <p className="add_points">+</p> : <p className="remove_points">-</p>}</div>
                  <div>{item.reason}</div>
                  <div className={item.points > 0 ? "add_points" : "remove_points"} style={{ textAlign: "end" }}>
                    {item.points}
                  </div>
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
};

export default PointsHistory;
